export default __webpack_public_path__ + "static/media/menu_my_recordings_okara.39d27d87.svg";